
  const contactType = {
    path: "/contactType",
    name: "contactType",
    component: () => import(/* webpackChunkName: "contact_type" */ "@/components/contactType/ContactTypeIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "contact_type" */ "@/components/contactType/ContactTypeView.vue"), name: "contactTypeView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "contact_type" */ "@/components/contactType/ContactTypeEdit.vue"), name: "contactTypeEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "contact_type" */ "@/components/contactType/ContactTypeCreate.vue"), name: "contactTypeCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default contactType;
    